// Scoreboard Podcast Takeover Configuration
// This takeover runs for 7 days with daily themed grids featuring different players

export const scoreboardTakeover = {
  startDate: "2026-05-21",
  endDate: "2026-05-27",

  days: [
    {
      date: "2026-05-21",
      episodeNumber: 135,
      guestName: "Jack Riewoldt",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/6zJWXfw8p9iVlPyguWIuZ3?si=nPDsjh-HRbibFB4WS4q0wg",
      description:
        "Richmond legend Jack Riewoldt joins Chris Titley for an open and grounded conversation about life beyond the AFL — parenting, purpose, the leadership lessons that fuelled Richmond's 2017 turnaround, and a 'scoreboard moment' with his dad.",
      backgroundImage: "/img/partners/scoreboard/thumbs/riewoldt.jpg",
    },
    {
      date: "2026-05-22",
      episodeNumber: 155,
      guestName: "Brandon Starcevich",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7kmNZOCWvJ3ZETXBVVMRmw?si=-_RVhdnnSL-OJGbzKl1QQw",
      description:
        "Brandon Starcevich joins Chris Titley to unpack premiership success, free agency pressure and the mindset behind performing on the biggest stage.\n\nFrom breathing and visualisation to resilience and preparation, this is a raw insight into elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/starcevich.jpg",
    },
    {
      date: "2026-05-23",
      episodeNumber: 140,
      guestName: "Darcy Gardiner",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7mwHDCinRsRcgvpNek9Cit",
      description:
        "Brisbane Lions premiership defender Darcy Gardiner sits down for his first in-person podcast — patience, personal evolution, the leadership shift that sparked Brisbane's turnaround, and how reviewing the 2023 loss shaped 2024 redemption.",
      backgroundImage: "/img/partners/scoreboard/thumbs/gardiner.jpg",
    },
    {
      date: "2026-05-24",
      episodeNumber: 27,
      guestName: "Hayden McLean",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7EGSV5VVriUPBBBMG1WT9q",
      description:
        "Sydney Swans forward Hayden McLean reflects on his 2024 season — AFL Grand Finals, the work behind 79 games and 75 goals, and the path that took him from outside the system to inside the forward fifty.",
      backgroundImage: "/img/partners/scoreboard/thumbs/mclean.webp",
    },
    {
      date: "2026-05-25",
      episodeNumber: 163,
      guestName: "Zach Tuohy",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/1es3fIgq6NdkMFTCwft7M8",
      description:
        "Confidence, Culture and the Long Road In. The most-capped Irish player in AFL history on confidence that only existed during games, reinventing yourself at a new club, and realising 'making it' doesn't magically fix everything.",
      backgroundImage: "/img/partners/scoreboard/thumbs/tuohy.webp",
    },
    {
      date: "2026-05-26",
      episodeNumber: 86,
      guestName: "Simon Black",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/6cD3PaYaG1AfwSnnfoRSbQ",
      description:
        "Consistency, Clarity & Crafting a Champion Mindset. AFL Hall of Famer Simon Black on Mount Isa to the MCG, overcoming Shulman's disease as a teenager, visualising every play before grand finals, and a 30-second wake-up from his mum.",
      backgroundImage: "/img/partners/scoreboard/thumbs/black.jpg",
    },
    {
      date: "2026-05-27",
      episodeNumber: 8,
      guestName: "Dale Morris",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/2xy2URjXJENnMQq99YfkAV",
      description:
        "Rejection, Redemption & the Tackle That Made History. Bulldogs premiership hero Dale Morris on years of being overlooked, mailing out VHS tapes to get noticed, his 'last chance' rookie trial, that iconic tackle on Buddy Franklin, and now building culture as an assistant coach at the Lions.",
      backgroundImage: "/img/partners/scoreboard/thumbs/morris.webp",
    },
  ],
};

// Helper function to check if takeover is currently active
export function isTakeoverActive(currentDate) {
  const current = new Date(currentDate);
  const start = new Date(scoreboardTakeover.startDate);
  const end = new Date(scoreboardTakeover.endDate);

  // Set to midnight for accurate date comparison
  current.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  return current >= start && current <= end;
}

// Helper function to get the daily configuration for a specific date
export function getDailyConfig(dateKey) {
  return scoreboardTakeover.days.find((day) => day.date === dateKey);
}
